import React, { useState, useEffect, useRef } from 'react'
import menuico from './images/Menub.webp'
import Logoicono from './images/logosvg2.jsx';
import FloatingMenu from './FloatingMenu'
import { Link } from 'react-router-dom';
export default function Encabezado(props) {
  const [menuVisible, setMenuVisible] = useState(false)
  const toggleMenu = () => {
    setMenuVisible(!menuVisible)
  }

  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setMenuVisible(false); // Cerrar el menú si el clic es fuera
      }
    };
    
    const handleScroll = () => {
      setMenuVisible(false); // Cerrar el menú al hacer scroll
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    document.addEventListener('scroll', handleScroll);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
      document.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
    <div className='Encabezado'>
      <div className='Menu' ref={buttonRef} onClick={toggleMenu}>
        <img id='Menu-before-icon' src={menuico} alt='Menu'/>
      </div>
      <Link className='Link-Titulo' to={'/'}>
        <div id='Titulo'>
        <div className='logopequeno'><Logoicono/></div>
          <h1>Chamuscón</h1>
        </div>
      </Link>
      <div id='Login'><h6>Iniciar Sesion</h6></div>
    
    </div>
      <FloatingMenu visible={menuVisible} toggleMenu={toggleMenu} menuRef={menuRef}/>
</>
  )
}